import { render, staticRenderFns } from "./RadioInputCustom.vue?vue&type=template&id=5818730c"
import script from "./RadioInputCustom.vue?vue&type=script&lang=js"
export * from "./RadioInputCustom.vue?vue&type=script&lang=js"
import style0 from "./RadioInputCustom.vue?vue&type=style&index=0&id=5818730c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports